<template>
  <div class="galeria-imagenes">
    <b-card header="Imágenes del Presupuesto Interno">
      <b-row>
        <template v-for="{ fileName, url, key } in imagenes">
          <b-col cols="12" md="4" :key="key">
            <b-card no-header class="galeria-imagen">
              <template v-if="isImagen(fileName)">
                <b-img fluid
                  @click="consultarImagen(url)"
                  :src="url"></b-img>
              </template>
              <template v-if="isPDF(fileName)">
                <div class="galeria-pdf">
                  <i class="fa fa-file-pdf-o fa-2x" @click="consultarPDF(url, fileName)"></i>
                  <label @click="consultarPDF(url, fileName)">{{ fileName }}</label>
                </div>
                <!-- <label>PDF</label> -->
              </template>  
              <div class="footer readonly">
                <b-button size="sm" variant="primary" class="footer-button" 
                  @click.prevent="descargarImagen(url, fileName)">Descargar</b-button>
              </div>
            </b-card>
          </b-col>
        </template>
      </b-row>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="descargarImagenes">Descargar Todo</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "presupuestointerno/getField",
  mutationType: "presupuestointerno/updateField",
});

export default {
  name: 'PresupuestosInternosImagenes',
  components: {
    appImagen: Imagen,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    presupuestoInternoId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selectedImageUrl: ''
    }
  },
  computed: {
    ...mapFields([
	    'imagenes',
    ]),
  },
  created() {
    this.$store.dispatch('presupuestointerno/getImagenesRemitos', this.presupuestoInternoId)
      .catch(err => this.showErrorMsj(err));
  },
  methods: {
    isImagen(fileName) {
      let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
      if (fileExtension == 'jpg' 
          || fileExtension == 'png'
          || fileExtension == 'jpeg') {
        return true;
      }
      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    close() {
      let params = {
        ordenTrabajoId: this.ordenTrabajoId,
        tieneImagenes: false
      }
      if (this.imagenes) {
        if (this.imagenes.length != 0) {
          params.tieneImagenes = true;
        }    
      }

      this.$emit('close', params);
    },
    descargarImagen(imageUrl, imagenName) {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, imagenName);
        });
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    descargarImagenes() {
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/descargarImagenes', this.presupuestoInternoId)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
}
</script>